export enum DeviceSize {
  DEFAULT = '', // mobile, phone 479px and below
  XS = 'xs', // small outlier 320 x 568
  SM = 'sm', // tablet 480px - 767px
  MD = 'md', // laptop 768px - 1023px
  LG = 'lg', // desktop 1024px and up
  XL = 'xl', // large outlier 1728 x 1117
}

export enum Size {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export enum PriceFairness {
  HIGH = 'HIGH',
  FAIR = 'FAIR',
  LOW = 'LOW',
}

export enum Product {
  ACA = 'ACA',
  ASO = 'ASO',
  FIXED_INDEMNITY = 'FIXED_INDEMNITY',
  GFI = 'GFI',
}

export enum ProviderType {
  INDIVIDUAL = 'individual',
  ORGANIZATION = 'organization',
  PHARMACY = 'pharmacy',
}

export enum Sentiment {
  ACCENT = 'accent', // Blue
  BRAND = 'brand',
  DEFAULT = 'default', // Gray
  ENGAGE = 'engage', // Teal
  ENGAGE_ON_COLOR = 'engageOnColor',
  INVERSE = 'inverse',
  NOTIFY = 'notify', // Yellow
  POSITIVE = 'positive', // Teal
  PRIMARY = 'primary', // Blue
  RISK = 'risk', // Red
  WEAK = 'weak',
}

/** Visual weight/importance of map markers */
export enum MarkerWeight {
  DEFAULT = 'default',
  BOLD = 'bold',
  HEAVY = 'heavy',
}
